import { useCollectiveContext } from 'context/CollectiveContext'
import { NextPage } from 'next'

// Use this HOC when you component *must* be rendered in
// the context of a collective, and cannot function w/o
// collective data

function withRequireCollective(WrappedComponent: NextPage) {
  function Component(props) {
    const { collectiveId } = useCollectiveContext()
    if (!collectiveId) {
      return null
    }

    return <WrappedComponent {...props} />
  }

  return Component
}

export default withRequireCollective
